export function beliefsBlock() {
  let count = 0;
  $('.beliefs-item').each(function(index, el) {
    $(this).css('transition-delay', `${count}s`);
    count += 0.15;
  });

}


// WEBPACK FOOTER //
// ./assets/js/modules/beliefs-block.js